import React from "react";
import styles from "./index.module.scss";
import { AddButtonProps } from "./types";

const AddButton: React.FC<AddButtonProps> = ({ onAdd, label }) => {
    return (
        <div className="d-flex justify-content-center mb-4 mt-2">
            <button
                type="button"
                onClick={onAdd}
                className={styles.addButton}
            >
                + {label}
            </button>
        </div>
    );
};

export default AddButton;
